'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import NotUpdatedInLastXDays from 'customer-data-filters/filterQueryFormat/operator/NotUpdatedInLastXDays';
import PropTypes from 'prop-types';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UpdatedInLastXDays from 'customer-data-filters/filterQueryFormat/operator/UpdatedInLastXDays';
import FilterOperatorErrorType from '../propTypes/FilterOperatorErrorType';
import UIFormControl from 'UIComponents/form/UIFormControl';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorRollingPropertyUpdated = ({
  value,
  onChange,
  onBlur,
  error
}) => {
  const handleChangeNumberOfDays = ({
    target: {
      value: days
    }
  }) => onChange(SyntheticEvent(value.set('numberOfDays', days)));
  const isError = error.get('error');
  const errorMessage = error.get('message');
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
      position: "end",
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'customerDataFilters.FilterOperatorRollingPropertyUpdated.days'
      }),
      children: /*#__PURE__*/_jsx(UINumberInput, {
        min: 0,
        onBlur: onBlur,
        onChange: handleChangeNumberOfDays,
        value: value.numberOfDays
      })
    })
  });
};
FilterOperatorRollingPropertyUpdated.propTypes = {
  error: FilterOperatorErrorType.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.instanceOf(UpdatedInLastXDays).isRequired, PropTypes.instanceOf(NotUpdatedInLastXDays).isRequired]).isRequired
};
export default FilterOperatorRollingPropertyUpdated;